
    import Vue from 'vue';
    import Component from 'vue-class-component';
    import {
        PositionApiModel, SeafarerCharacteristicModel, SeafarerMaritimeInfoModel
    } from "@/api-client";
    import {Prop} from "vue-property-decorator";
    import HeadingGroup from "@/features/shared/components/HeadingGroup.vue";
    import LabelOptional from "@/features/shared/components/LabelOptional.vue";

    @Component({
        components: {
            HeadingGroup,
            LabelOptional,
        },
    })
    export default class SeafarerMaritimeInfo extends Vue {
        @Prop({required: true})
        model!: SeafarerMaritimeInfoModel;

        @Prop({required: true})
        characteristics!: SeafarerCharacteristicModel[];

        save(){
            this.$emit("maritime-info-saved");
        }
    }
